/*!
 *
 * tab.js
 *
 */


$.fn.tab = function(){
	return this.each(function(){
		var $nav = $(this).find('.is-Tab_Nav_Item_Link');
		var $contents = $(this).find('.is-Tab_Contents_Item');
		$nav.on('tap', function(e){
			e.preventDefault();
			if ( !$(this).is('.is-Tab_Nav_Item_Link-active') ){
				var target = $(this).attr('href');
				$nav.removeClass('is-Tab_Nav_Item_Link-active');
				$contents.removeClass('is-Tab_Contents_Item-active');
				$(this).addClass('is-Tab_Nav_Item_Link-active');
				$(target).addClass('is-Tab_Contents_Item-active');
			};
		});
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/tab.js
// module id = 24
// module chunks = 0